import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import './Footer.css';

const COLS = [
  {
    title: 'Treatments',
    links: [
      { label: 'Pain Medicine',       path: '/treatments/pain-medicine' },
      { label: 'Stem Cell Therapy',   path: '/treatments/pain-medicine' },
      { label: 'PRP & BMAC',          path: '/treatments/pain-medicine' },
      { label: 'Sports Orthopaedics', path: '/treatments/orthopaedics' },
      { label: 'Arthroscopy',         path: '/treatments/orthopaedics' },
      { label: 'Physiotherapy',       path: '/treatments/physiotherapy' },
    ],
  },
  {
    title: 'Conditions',
    links: [
      { label: 'Chronic Joint Pain', path: '/conditions' },
      { label: 'Back & Spine Pain',  path: '/conditions' },
      { label: 'Sports Injuries',    path: '/conditions' },
      { label: 'Knee Problems',      path: '/conditions' },
      { label: 'Shoulder Issues',    path: '/conditions' },
      { label: 'Arthritis',          path: '/conditions' },
    ],
  },
  {
    title: 'Quick Links',
    links: [
      { label: 'About Us',       path: '/about' },
      { label: 'Our Doctors',    path: '/doctors' },
      { label: 'Testimonials',   path: '/testimonials' },
      { label: 'Book Appointment', path: '/contact' },
      { label: 'Contact Us',     path: '/contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <div className="footer-logo-icon">
              <img src={logo} alt="TheOrthomed Logo" style={{width:'100%', height:'100%', objectFit:'contain', display:'block', padding:'4px'}} />
            </div>
            {/* <div>
              <div className="footer-logo-name">THE ORTHOMED</div>
              <div className="footer-logo-sub">Sports Ortho + Regenerative Medicine</div>
            </div> */}
          </Link>
          <p className="footer-desc">
            Hyderabad's premier center for regenerative pain medicine, sports orthopaedics, and evidence-based physiotherapy. Healing without surgery.
          </p>
          <div className="footer-contact-info">
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📍</span>
              <span>Hyderabad, Telangana.</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📞</span>
              <span>+91 9989346471</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">✉️</span>
              <span>theorthomed@gmail.com</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">🕐</span>
              <span>Mon – Sat: 9:00 AM – 9:00 PM</span>
            </div>
          </div>
        </div>

        {COLS.map(col => (
          <div key={col.title} className="footer-col">
            <h4 className="footer-col-title">{col.title}</h4>
            <ul>
              {col.links.map(l => (
                <li key={l.label}>
                  <Link to={l.path} className="footer-link">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© 2026 TheOrthomed. All rights reserved. | <a href="https://theorthomed.com" style={{color:'var(--accent)'}}>theorthomed.com</a></p>
          <p style={{color:'rgba(255,255,255,0.35)', fontSize:12}}>Advanced Sports Ortho + Regenerative Medicine Center, Hyderabad</p>
        </div>
      </div>
    </footer>
  );
}
